import { render, staticRenderFns } from "./GenericTermsControl.vue?vue&type=template&id=24deddd1&"
import script from "./GenericTermsControl.vue?vue&type=script&lang=js&"
export * from "./GenericTermsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports